module.exports = __webpack_public_path__ + "static/tools_03-560x320-5b4782fd136e8ab8a3d1058895f469dd.jpg";